import axios from "axios";

const AUTH_API_BASE_URL = process.env.REACT_APP_API_BASE_URL + "/auth";

class AuthService {
  login(payload) {
    return axios.post(AUTH_API_BASE_URL + "authenticate", payload).then(
      (response) => {
        return response;
      },
      (error) => {
        console.log(error.response);
      }
    );
  }

  logout() {
    localStorage.removeItem("user");
  }

  getCurrentUser() {
    const userStr = localStorage.getItem("user");
    if (userStr) {
      return JSON.parse(userStr);
    }

    return null;
  }

  refreshToken(token) {
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios.post(
      AUTH_API_BASE_URL + "/refresh-token",
      {
        refreshToken: token,
      },
      config
    );
  }
}

export default new AuthService();
